import styled from 'styled-components'
import { ReactComponent as BaseInformationIcon } from '@sketch/icons/circle-information-button-translucent-17'

export const InformationIcon = styled(BaseInformationIcon)`
  width: 17px;
  display: block;
`
